export const role = {
  name: "Role |||| Roles",
  fields: {
    name: "Name",
    description: "Description",
    systemName: "System Name",
    permissionIds: "Permissions",
    createdAt: "Created at",
    updatedAt: "Updated at",
  },
};
